import React from 'react';
import moment from 'moment/min/moment-with-locales';
import { colors } from "../components/Theme/WebTheme";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  FormControl,
  Radio,
  RadioGroup,
  Modal,
  FormLabel,
  Button,
   Card, CardContent, CardActions, Avatar
} from '@mui/material';
import { useTranslation } from "react-i18next";
import OtherPerson from 'components/OtherPerson';
import StarIcon from '@mui/icons-material/Star';
import { IconButton } from '@mui/material';
import FileDownload from '@mui/icons-material/FileDownload';
import { StreamChat } from 'stream-chat';
import { ChatApiKey } from 'config/FirebaseConfig';
import { firebase } from 'common/src/config/configureFirebase';
import { fetchNotifications } from 'common/src/actions/notificationactions';

export const calcEst = false;
export const showEst = true;
export const optionsRequired = true;

export const MAIN_COLOR = colors.DELIVERYPRIMARY;
export const SECONDORY_COLOR = colors.DELIVERYSECONDORY;

export const FONT_FAMILY =  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", "Roboto", sans-serif';

export const bookingHistoryColumns = (role, settings, t, isRTL, openReviewModal) => [
  { title: t("booking_ref"), field: "reference" },
  {
    title: t("booking_date"),
    field: "bookingDate",
    render: (rowData) =>
      rowData.bookingDate ? moment(rowData.bookingDate).format("lll") : null,
  },
  // { title: t('car_type'), field: 'carType',  },
  {
    title: t("assign_driver"),
    field: "driver_name",
    render: (rowData) => {
      const firstDriverKey = rowData?.driverOffers && Object.keys(rowData?.driverOffers)[0];
      const firstDriver = rowData?.driverOffers && rowData?.driverOffers[firstDriverKey];
      return firstDriver?.driver_name ||rowData?.driver_name|| 'nessun conducente assegnato!'
    },
  },
  {
    title: t("booking_status_web"),
    field: "status",
    render: (rowData) => (
      <div
        style={{
          backgroundColor:
            rowData.status === "CANCELLED"
              ? colors.RED
              : rowData.status === "COMPLETE"
              ? colors.GREEN
              : colors.YELLOW,
          color: "white",
          padding: 7,
          borderRadius: "15px",
          fontWeight: "bold",
          width: "150px",
          margin: "auto",
        }}
      >
        {t(rowData.status)}
      </div>
    ),
  },
  {
    title: t("trip_cost"),
    field: "trip_cost",
    render: (rowData) => {
      const firstDriverKey = rowData?.driverOffers && Object.keys(rowData?.driverOffers)[0];
      const firstDriver = rowData?.driverOffers && rowData?.driverOffers[firstDriverKey];
      const tripCost = firstDriver?.trip_cost|| rowData?.trip_cost;
      return tripCost
        ? settings.swipe_symbol
          ? tripCost  + " " + settings.symbol
          : settings.symbol + " " + tripCost
        : settings.swipe_symbol
        ? "0 " + settings.symbol
        : settings.symbol + " 0";
    },
  },
  {
    title: t("review"),
    field: "review",
    render: (rowData) => {
      const firstDriverKey = rowData?.driverOffers && Object.keys(rowData.driverOffers)[0];
      const firstDriver = rowData?.driverOffers && rowData.driverOffers[firstDriverKey];
     return rowData.status !== "COMPLETE"? `${firstDriver?.driverRating|| rowData?.driverRating || '0'} stelle`:  
      rowData?.rating ? `${rowData?.rating} stelle`:   <div onClick={() =>openReviewModal(rowData)}
      style={{
        backgroundColor:'#4dd1c6',
        color: "black",
        padding: 7,
        borderRadius: "15px",
        fontWeight: "bold",
        width: "150px",
        margin: "auto",
      }}
    >
      {t('review_now')}
    </div>
    },
  },
  {
    title: t("invoice"),
    field: "invoiceDownload",
    render: (rowData) => {
      if(rowData.status !== "COMPLETE"){
        return;
      }
      console.log('rowData:',  rowData)
      return (
        <IconButton
          onClick={() => generateInvoice({ ...rowData, symbol: settings?.symbol })}
          aria-label="download invoice"
        >
          <FileDownload style={{ color: "#3f51b5" }} />
        </IconButton>
      );
    },
  },
];

const downloadInvoice = async(bookingReference) => {
  await generateInvoice(bookingReference)

  alert(`Downloading invoice for booking reference: ${bookingReference?.reference}`);
};

export const generateInvoice = async (invoiceData) => {
  try {
    // Validate that invoiceData is not empty
    if (!invoiceData || Object.keys(invoiceData).length === 0) {
      console.log('Invoice data is empty or undefined');
    }

    const baseUrl = `https://us-central1-${firebase.config.projectId}.cloudfunctions.net/generate_invoice`
    console.log('data:', {
      id: invoiceData.id,
      customer_name: invoiceData.customer_name,
      customer_email: invoiceData.customer_email,
      pickupAddress: invoiceData.pickupAddress,
      dropAddress: invoiceData.dropAddress,
      trip_cost: invoiceData.trip_cost,
      driver_name: invoiceData.driver_name,
      driver_contact: invoiceData.driver_contact
    })

    const response = await fetch(baseUrl, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          id: invoiceData.id,
          reference: invoiceData.reference,
          customer_name: invoiceData.customer_name,
          customer_email: invoiceData.customer_email,
          customer_contact: invoiceData.customer_contact,
          pickupAddress: invoiceData.pickupAddress,
          dropAddress: invoiceData.dropAddress,
          trip_cost: invoiceData.trip_cost,
          customer_paid: invoiceData.customer_paid,
          paidBy: invoiceData.paidBy,
          driver_name: invoiceData.driver_name,
          driver_contact: invoiceData.driver_contact,
          carType: invoiceData.carType,
          vehicle_number: invoiceData.vehicle_number,
          distance: invoiceData.distance,
          bookingDate: invoiceData.bookingDate,
          tripdate: invoiceData.tripdate,
          trip_start_time: invoiceData.trip_start_time,
          trip_end_time: invoiceData.trip_end_time,
          symbol: invoiceData.symbol,
        }
      })
  })

    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));

    if (!response.ok) {
      const errorText = await response.text();
      console.log(`Server responded with ${response.status}: ${errorText}`);
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/pdf')) {
      console.log(`Unexpected content type: ${contentType}`);
      return;
    }

    const blob = await response.blob();
    
    if (blob.size === 0) {
      console.log('Received empty PDF file');
      return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    const fileName = invoiceData.reference
      ? `Ricevuta_${invoiceData.reference}.pdf`
      : invoiceData.id
        ? `Ricevuta_${invoiceData.id.slice(-6).toUpperCase()}.pdf`
        : `Ricevuta_${new Date().getTime()}.pdf`;
      
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      link.remove();
      window.URL.revokeObjectURL(url);
    }, 100);

    return true;

  } catch (error) {
    console.error('Invoice generation error:', error);
    alert(`Error generating invoice: ${error.message}`);
  }
};


export const BookingModalBody = (props) => {
    const { t, i18n  } = useTranslation();
    const isRTL = i18n.dir();
    const { classes, instructionData, handleChange, auth, profileData, settings, deliveryWithBid, otherPerson, setOtherPerson } = props;
    return (
      <Grid item xs={12}>
        <span>
            <Typography component="h2" variant="h5" style={{marginTop:15, color:colors.BLACK, fontFamily:FONT_FAMILY}}>
                {t('delivery_information')}
            </Typography>
            {auth.profile.usertype === 'customer' && !auth.profile.email ?
            <Grid item xs={12}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                variant="outlined"
                margin="normal"
                required = {auth.profile.email ? false : true }
                fullWidth
                id="email"
                label={t('email')}
                name="email"
                autoComplete="email"
                onChange={handleChange}
                value={profileData.email}
                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }

            <OtherPerson
              classes = {classes}
              otherPerson={otherPerson}
              handleChange={handleChange}
              setOtherPerson={setOtherPerson}
              instructionData={instructionData}
            />

            <Grid item xs={12}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                variant="outlined"
                margin="normal"
                fullWidth
                id="pickUpInstructions"
                label={t('pickUpInstructions')}
                name="pickUpInstructions"
                autoComplete="pickUpInstructions"
                onChange={handleChange}
                value={instructionData.pickUpInstructions}
                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                variant="outlined"
                margin="normal"
                fullWidth
                id="deliveryInstructions"
                label={t('deliveryInstructions')}
                name="deliveryInstructions"
                autoComplete="deliveryInstructions"
                onChange={handleChange}
                value={instructionData.deliveryInstructions}
                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            {settings.bookingFlow === "0" && auth.profile.usertype === 'customer' ? 
              <Grid item xs={12}>
             <RadioGroup row name="bookingFlow" value={deliveryWithBid} onChange={handleChange}>
               <FormControlLabel key={"key0"} value={0} control={<Radio />} label={ <Typography className={classes.typography}>{t('system_price')}</Typography>} />
               <FormControlLabel key={"key1"} value={1} control={<Radio />} label={ <Typography className={classes.typography}>{t('bid')}</Typography>} />
             </RadioGroup>
           </Grid>
            :null}
        </span>
      </Grid>
    )
}

export const validateBookingObj = (t, bookingObject, instructionData) => {
    delete bookingObject.driverEstimates;
    return { bookingObject };
}

export const PanicSettings = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { classes, data, handleTextChange } = props;
  return (
      <span>
          <Typography component="h1" variant="h5" style={{ marginTop: '15px', textAlign: isRTL === 'rtl' ? 'right' : 'left',fontFamily:FONT_FAMILY }}>
              {t('panic_num')}
          </Typography>
          <TextField
              InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
              variant="outlined"
              margin="normal"
              fullWidth
              id="panic"
              label={t('panic_num')}
              className={isRTL === "rtl" ? [classes.rootRtl_1, classes.right] : classes.textField}
              name="panic"
              autoComplete="panic"
              onChange={handleTextChange}
              value={data.panic}
          />
      </span>
  )
}

export const DispatchSettings = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { autoDispatch, onChange } = props;
  return (
      <FormControlLabel
          style={{ flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
          control={
              <Switch
                  checked={autoDispatch}
                  onChange={onChange}
                  name="autoDispatch"
                  color="primary"
              />
          }
          label={ <Typography style={{fontFamily:FONT_FAMILY}}>{t('auto_dispatch')}</Typography>}
    />
  )
}

export const BookingImageSettings = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { data, handleSwitchChange } = props;
  return (
      <span>
          <FormControlLabel
            style={{ marginTop: '10px', flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
            control={
              <Switch
                checked={data.AllowDeliveryPickupImageCapture}
                onChange={handleSwitchChange}
                name="AllowDeliveryPickupImageCapture"
                color="primary"
              />
            }
            label={ <Typography style={{fontFamily:FONT_FAMILY}}>{t('allow_del_pkp_img')}</Typography>}
          />
          <FormControlLabel
            style={{ marginTop: '10px', flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
            control={
              <Switch
                checked={data.AllowFinalDeliveryImageCapture}
                onChange={handleSwitchChange}
                name="AllowFinalDeliveryImageCapture"
                color="primary"
              />
            }
            label={ <Typography style={{fontFamily:FONT_FAMILY}}>{t('allow_del_final_img')}</Typography>}
          />
      </span>
  )
}

export const carTypeColumns = (t, isRTL, onClick) =>  [
  { title: t('name'), field: 'name',
  },
  { title: t('image'),  field: 'image',
    initialEditValue: 'https://cdn.pixabay.com/photo/2012/04/15/22/09/car-35502__480.png',
    render: rowData => rowData.image? <button onClick={()=>{onClick(rowData)}}><img alt='CarImage' src={rowData.image} style={{width: 50}}/></button>:null
  },
  { title: t('base_fare'), field: 'base_fare', type: 'numeric', 
   initialEditValue: 0 },
  { title: t('rate_per_unit_distance'), field: 'rate_per_unit_distance', type: 'numeric', 
   initialEditValue: 0},
  { title: t('rate_per_hour'), field: 'rate_per_hour', type: 'numeric', 
   initialEditValue: 0},
  { title: t('min_fare'), field: 'min_fare', type: 'numeric', 
  initialEditValue: 0},
  { title: t('convenience_fee'), field: 'convenience_fees', type: 'numeric', 
   initialEditValue: 0},
  {
    title: t('convenience_fee_type'),
    field: 'convenience_fee_type',
    lookup: { flat: t('flat'), percentage: t('percentage')},
  },
  {
    title: t('fleet_admin_comission'), field: 'fleet_admin_fee', type: 'numeric', 
   initialEditValue: 0
  },
  { title: t('extra_info'), field: 'extra_info' ,
},
  { title: t('position'), field: 'pos', type: 'numeric', defaultSort:'asc'}
];

export const acceptBid = (selectedBooking, selectedBidder) => {
  let bookingObj = {...selectedBooking};
  bookingObj.selectedBid = bookingObj.driverOffers[selectedBidder];
  const uid = bookingObj.selectedBid.driver;
  for(let key in bookingObj.driverOffers){
    if(key !== uid){
       delete  bookingObj.driverOffers[key];
    }
  }
  for(let key in bookingObj.requestedDrivers){
      if(key !== uid){
        delete  bookingObj.requestedDrivers[key];
      }
  }
  return bookingObj;
}

export const BidModal = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { ref, role, selectedBooking, bidModalStatus,handleBidModalClose, classes, settings, acceptBid, selectedBidder, handleChange } = props;
  return selectedBooking &&
    selectedBooking?.driverOffers &&
    role === "customer" ? (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={bidModalStatus}
      onClose={handleBidModalClose}
      className={classes.modal}
      container={() => ref}
    >
      <Grid container spacing={2} className={classes.paper}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl component="fieldset"> 
            <RadioGroup
             
              value={selectedBidder}
            >
              {selectedBooking && selectedBooking?.driverOffers && Object.keys(selectedBooking?.driverOffers).map((key) => {
                const driver = selectedBooking?.driverOffers[key];
                return (
                  <Grid className={classes.card}>
                    <Avatar
                      className={classes.avatar}
                      src={
                        driver?.image
                          ? driver.image
                          : "https://img.freepik.com/premium-vector/user-profile-icon-flat-style-member-avatar-vector-illustration-isolated-background-human-permission-sign-business-concept_157943-15752.jpg"
                      }
                    />

                    <div>
                      <Typography className={classes.typography}>
                        {driver?.driver_name}
                      </Typography>
                      {/* <Typography variant="body2">{offer.dateTime}</Typography> */}
                    </div>
                    <div className={classes.rating}>
                      {Array(5)
                        .fill()
                        .map((_, i) => (
                          <StarIcon  className={i < driver?.driverRating ? classes.starFilled : classes.starEmpty}
                            key={i}
                            color={
                              i < driver?.driverRating ? "primary" : "disabled"
                            }
                          />
                        ))}
                    </div>
                    <div>
                      <Typography className={classes.price}>
                        ${driver?.bidPrice}
                      </Typography>
                    </div>
                    <Button     value={selectedBidder}   name="selectedBidder"
                      variant="contained"
                      color='success'
                      type="submit"
                      style={{
                        ...(isRTL === "rtl"
                          ? { marginRight: 10 }
                          : { marginLeft: 10 }),
                        fontFamily: FONT_FAMILY,
                      }}
                      onClick={() =>{
                        handleChange(driver)
                        acceptBid(driver, driver)
                      }}
                    >
                      {t("accept")}
                    </Button>
                  </Grid>
                );
              })}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Modal>
  ) : null;
}

export const  downloadCsv = (data, fileName) => {
  const finalFileName = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
  a.setAttribute("download", finalFileName);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export const DeliveryFlow = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { data , handleChange } = props;
  return(
  <span>
    <Typography component="h1" variant="h5" style={{ marginTop: '15px', textAlign: isRTL === 'rtl' ? 'right' : 'left',fontFamily:FONT_FAMILY }}>
        {t('booking_type')}
    </Typography>

    <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
      <FormControl component="fieldset">
      <RadioGroup  row name="booking_type" value={data} onChange={handleChange}>
          <FormControlLabel key={"key0"} value={0} control={<Radio />} label={ <Typography fontFamily={FONT_FAMILY}>{t('system_price_with_bid')}</Typography>}/>
          <FormControlLabel key={"key1"} value={1} control={<Radio />} label={ <Typography fontFamily={FONT_FAMILY}>{t('system_price')}</Typography>} />
          <FormControlLabel key={"key2"} value={2} control={<Radio />} label={ <Typography fontFamily={FONT_FAMILY}>{t('bid')}</Typography>} />
        </RadioGroup>
      </FormControl>
    </Grid>
  </span>
  )
} 

export const CustomerBidSettings = (props) => {
  return null;
}
export const client = StreamChat.getInstance(ChatApiKey);


export const initializeChatUser = async (user) => {
  try {
    console.log('user:', user)
    console.log('client:', client?.userID)
    if(client?.userID){
      return;
    }
    if(!user){
      return
    }
    let url = `https://us-central1-${firebase.config.projectId}.cloudfunctions.net/generate_chat_token`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: user?.uid,
      }),
    });
    const json = await response.json();
    await client.connectUser(
      {
        id: user?.uid,
        name: user?.firstName,
      },
      json?.token,
    );
  } catch (error) {
    console.log("error:", error);
  }
};

export const initiateChat = async ({senderId, reciever}) => {
  try {
    if(!senderId||!reciever?.id){
      return alert('sender id and reciever id is missing...')
    }
    const filters = {
      type: 'messaging',
      id: {$in: [senderId, reciever?.id]},
    };

    const response = await client.queryUsers({ id: reciever?.id });
    const  existingReciever =  response.users.length > 0;

    if(!existingReciever){
      let url = `https://us-central1-${firebase.config.projectId}.cloudfunctions.net/upsert_user`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          recieverId: reciever?.id,
          recieverName: reciever?.firstName,
        }),
      });
      const json = await response.json();
      console.log("jsons:", json);
    }
    
    const existingChannels = await client.queryChannels(filters);
    let channel;
    if (existingChannels?.length > 0) {
      channel = existingChannels[0];
    } else {
    channel = client.channel('messaging', {
        members: [senderId, reciever?.id],
    });
      await channel.create();
    }
    return true;

  } catch (error) {
    console.log('code:', error.code)
    console.log('initiateChat error:', error);
    return false;
  }
};



export const markNotificationAsRead = async ({userId, notificationId}) => {
  try {
    console.log({userId, notificationId})

  let url = `https://us-central1-${firebase.config.projectId}.cloudfunctions.net/mark_notification_as_read`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: userId,
      notificationId: notificationId,
    })
  })
  const json = await response.json();
    
  } catch (error) {
    console.log('error:', error)
  }
};